import { render, staticRenderFns } from "./DirectorySearch2.vue?vue&type=template&id=0c24b0d9&"
import script from "./DirectorySearch2.vue?vue&type=script&lang=js&"
export * from "./DirectorySearch2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CASADEDIOS\\git\\global_business\\gpb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c24b0d9')) {
      api.createRecord('0c24b0d9', component.options)
    } else {
      api.reload('0c24b0d9', component.options)
    }
    module.hot.accept("./DirectorySearch2.vue?vue&type=template&id=0c24b0d9&", function () {
      api.rerender('0c24b0d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/frontend/js/components/DirectorySearch2.vue"
export default component.exports